import { render, staticRenderFns } from "./ResultEnglish.vue?vue&type=template&id=53d70802&scoped=true&lang=pug&"
import script from "./ResultEnglish.vue?vue&type=script&lang=ts&"
export * from "./ResultEnglish.vue?vue&type=script&lang=ts&"
import style0 from "./ResultEnglish.vue?vue&type=style&index=0&id=53d70802&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d70802",
  null
  
)

export default component.exports